<template>
  <el-dialog title="图标" custom-class="icondialog" :visible.sync="dialogVisible" @close="$emit('update:visible',false)" width="1120px">
    <div class="dialog_conwrap">
      <p class="iconTab">
        <span :class="tabIndex==index?'activeTab':''" @click="tabFn(index)" v-for="(item,index) in iconList"
              :key="index">{{item.name}}</span>
      </p>
      <div class="iconbody">
        <el-carousel
                :initial-index="tabIndex"
                :autoplay="autoplay"
                arrow="never"
                indicator-position="none"
                :loop="loopStatus"
                ref="carouselBox"
        >
          <el-carousel-item v-for="(item,k) in iconList" :key="k">
            <div class="iconbody_body_line">
              <div class="iconbody_left" v-if="item.is_set==0">
                <div class="iconbody_left_img" v-for="(items,idx) in item.icon" :key="idx" @click="checkIconFn(items)">
                  <img :src="items.light_pic" alt="">
                </div>
              </div>
              <div class="iconbody_left" v-else>
                <div class="iconbody_right_list" v-for="(items,indexs) in item.second" :class="radio==items.id?'active_list':''" :key="indexs">
                  <span class="iconbody_right_list_tab_radio">
                    <el-radio v-model="radio" :label="indexs">{{items.name}}</el-radio>
                  </span>
                  <div class="iconbody_right_list_right">
                    <span class="iconbody_right_list_tab" v-for="(itemsList,i) in items.icon" :key="i">
                      <img :src="itemsList.light_pic" alt="">
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </el-carousel-item>
        </el-carousel>
      </div>
    </div>
    <div v-if="iconList[tabIndex]"  slot="footer" class="dialog-footer">
      <span slot="footer" class="dialog-footer" v-if="iconList[tabIndex].is_set==1">
        <el-button @click="dialogVisible = false" size="small">取 消</el-button>
        <el-button type="primary" @click="saveIconTab()" size="small">确 定</el-button>
      </span>
    </div>
  </el-dialog>
</template>
<script>
  import api from "@/api.js";
  export default {
    name: "addColumnDialog",
    props: ["visible"],
    watch: {
      visible() {
        this.dialogVisible = this.visible;
      }
    },
    data() {
      return {
        tabIndex: 0,
        autoplay: false,
        loopStatus: false,
        dialogVisible: this.visible,
        radio: 'none',
        iconList: []
      };
    },
    created() {
      this.inintFn();
    },
    methods: {
      inintFn() {
        this.axios
            .post(api.bottom_navigation_cate, {})
            .then(response => {
              if (response.data.code == 0) {
                this.iconList = response.data.list.concat(response.data.sec_list);
              } 
            })
            .catch(response => {
            });
      },
      tabFn(option) {
        if(this.tabIndex!==option){
          this.radio = 'none'
        }
        this.tabIndex = option
        this.$refs.carouselBox.setActiveItem(option)
      },
      checkIconFn(option) {
        this.$emit('getIconSrc',option)
        this.dialogVisible = false
      },
      saveIconTab(){
        if(this.radio ==='none'){
          this.$message.error('请选择图标');
          return
        }
        this.$emit('getIconSrc',this.iconList[this.tabIndex].second[this.radio])
        this.dialogVisible = false
      }
    }
  };
</script>

